import React, { useState } from "react";
import { useQuery, useMutation } from "@apollo/client";
import { connect } from "react-redux";
import { ShowAlert } from "shared/actions/alert";
import { errorToDisplay } from "shared/actions/helpers";
import Sharing from "../component/Sharing";
import { ADD_REMOVE_FAMILY_FRIENDS, GET_FAMILY_FRIENDS_DATA, INVITE_PATIENT } from "../actions/SharingActions";

function SharingCont(props) {
   const { auth } = props;
   const patientId = auth?.userCredentials?.user?.id;
   const [familyFriendsList, setFamilyFriendsList] = useState([]);
   const [sharingList, setSharingList] = useState([]);
   const [selectedPatient, setSelectedPatient] = useState(null);
   const [loadingInvite, setLoadingInvite] = useState(false);
   const [searchKey, setSearchKey] = useState("");
   const [invite, setInvite] = useState(false);
   const { loading, refetch } = useQuery(GET_FAMILY_FRIENDS_DATA, {
      fetchPolicy: "no-cache",
      variables: {
         user: {
            id: patientId,
         },
         type: {
            isActive: true,
            type: "family",
         },
      },
      onCompleted(result) {
         const data = result?.getCareTeam || [];
         setFamilyFriendsList(data);
         setSharingList(data);
      },
      onError(err) {
         const errMessage = errorToDisplay(err);
         ShowAlert(errMessage, "error");
      },
   });
   const [addFriendsFamily] = useMutation(INVITE_PATIENT, {
      onCompleted(res) {
         ShowAlert(res?.addPatient?.status?.message);
         setLoadingInvite(false);
         refetch();
         setInvite(false);
         setSearchKey("")
      },
      onError(err) {
         const errMessage = errorToDisplay(err);
         ShowAlert(errMessage, "error");
         setLoadingInvite(false);
         setInvite(false);
      },
   });
   const addToFriendsFamily = (familyPayload) => {
      addFriendsFamily({
         variables: {
            patient: {
               contactInformation: {
                  email: familyPayload?.email,
                  mobileNumber: familyPayload?.mobileNo,
               },
               name: {
                  fullName: familyPayload?.name,
               },
            },
            familyInvite: true,
            selectedPatientId: patientId,
            relationship: familyPayload?.relationship,
         },
      });
   };
   const [removeFriendsFamily] = useMutation(ADD_REMOVE_FAMILY_FRIENDS, {
      onCompleted(res) {
         ShowAlert(res.addCareMember.message);
         const filteredFamilyMember = familyFriendsList?.filter(
            (filter) => filter?.careMember?.id !== selectedPatient || !filter?.isCareTeam
         );
         setFamilyFriendsList(filteredFamilyMember);
         setSharingList(filteredFamilyMember);
         setSelectedPatient(null);
      },
      onError(err) {
         const errMessage = errorToDisplay(err);
         ShowAlert(errMessage, "error");
      },
   });
   const removeFamilyMember = (family) => {
      removeFriendsFamily({
         variables: {
            careTeam: {
               userId: patientId,
            },
            queryType: "delete",
            careMemberId: family?.id,
         },
      });
   };
   return (
      <Sharing
         familyFriendsList={familyFriendsList}
         setFamilyFriendsList={setFamilyFriendsList}
         loading={loading}
         addToFriendsFamily={addToFriendsFamily}
         removeFamilyMember={removeFamilyMember}
         setSelectedPatient={setSelectedPatient}
         setLoadingInvite={setLoadingInvite}
         loadingInvite={loadingInvite}
         invite={invite}
         setInvite={setInvite}
         sharingList={sharingList}
         setSharingList={setSharingList}
         searchKey={searchKey}
         setSearchKey={setSearchKey}
         {...props}
      />
   );
}
const mapStateToProps = (state) => {
   return {
      auth: state?.auth,
   };
};

export default connect(mapStateToProps, null)(SharingCont);
